import React from "react";
import prIcon1 from "../../images/icon/document.svg";
import prIcon2 from "../../images/icon/bar-graph.svg";
import prIcon3 from "../../images/icon/clipboard.svg";

const ProjectSingleAloca = (props) => {
  return (
    <section className="wpo-project-single-section ">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="wpo-project-single-wrap">
              <div className="wpo-solutions-section section-padding">
                <h2>Deixe com a gente</h2>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="wpo-solutions-item">
                      <div className="wpo-solutions-icon">
                        <div className="icon">
                          <img src={prIcon1} alt="" />
                        </div>
                      </div>
                      <div className="wpo-solutions-text">
                        <h2>
                          <p className="fs-4">Gestão Ágil e Especializada</p>
                        </h2>
                        <h3 className="fs-4 fw-light">
                          Cuidamos da seleção e da alocação com eficiência,
                          permitindo que você foque no crescimento do seu
                          negócio.
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="wpo-solutions-item">
                      <div className="wpo-solutions-icon">
                        <div className="icon">
                          <img src={prIcon2} alt="" />
                        </div>
                      </div>
                      <div className="wpo-solutions-text">
                        <h2>
                          <p className="fs-4">Redução de Custos e Tempo</p>
                        </h2>
                        <h3 className="fs-4 fw-light">
                          Com nossa expertise, aceleramos a contratação e
                          otimizamos recursos, sem comprometer a qualidade.
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="wpo-solutions-item">
                      <div className="wpo-solutions-icon">
                        <div className="icon">
                          <img src={prIcon3} alt="" />
                        </div>
                      </div>
                      <div className="wpo-solutions-text">
                        <h2>
                          <p className="fs-4">Talentos no Lugar Certo</p>
                        </h2>
                        <h3 className="fs-4 fw-light">
                          Entregamos profissionais alinhados às necessidades e à
                          cultura da sua empresa, com segurança e precisão.
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="fs-4 text-center">
                  O serviço de Outplacement da Thomas Talent é desenvolvido de
                  forma personalizada e sigilosa, focado em apoiar profissionais
                  na construção do plano de carreira, atualização de currículo,
                  preparação para entrevistas e desenvolvimento de networking.
                  Além disso, oferecemos assessoria contínua e apoio
                  estratégico para inserção no mercado por meio da divulgação do
                  perfil a empresas e headhunters.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSingleAloca;
